import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EditorComponent } from './components/editor/editor.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/create'
  },
  {
    path: 'create/:digitalPreviewSlug/:addToCart',
    component: EditorComponent
  },
  {
    path: 'create/:digitalPreviewSlug',
    component: EditorComponent
  },
  {
    path: 'create',
    component: EditorComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /vercel/workpath0/src/app/app-routing.module.ts